import { useSearchParams } from 'react-router-dom';

export function useStateKey() {
  const [searchParams] = useSearchParams();
  const stateKey = searchParams.get('state_key');

  if (typeof stateKey === 'string') {
    return stateKey;
  }
}
